<template>
    <div class="position-box">
        <ul class="head-tab-box">
            <li class="tab tab1" @click="link(1)">{{$t('jghy.jghy')}}</li>
            <li class="tab tab3 active">{{$t('jghy.yxhy')}}</li>
            <li class="tab tab2" @click="link(2)">{{$t('footer.currency')}}</li>
        </ul>
        <div class="transaction-head">
            <img class="icon" v-if="!theme" src="@/assets/More.png" @click="leftShow" alt="">
            <img class="icon" v-else src="@/assets/trend_tabulate.png" @click="leftShow" alt="">
            <div class="text">{{symbol}}</div>
            <img class="icon" v-if="!theme" src="@/assets/Trend.png" alt=""  @click="kline(symbol,leftIdx)">
            <img class="icon" v-else src="@/assets/theme/hangqing.png" alt=""  @click="kline(symbol,leftIdx)">
        </div>
        <div class="item1-box">
            <div class="tab-box">
                <div class="tab" :class="{active: tradeIdx == 0}" @click="trade(0)">{{$t('hyjy.kc')}}</div>
                <div class="tab" :class="{active: tradeIdx == 1}" @click="trade(1)">{{$t('hyjy.pc')}}</div>
                <div class="tab" :class="{active: tradeIdx == 2}" @click="trade(2)">{{$t('hyjy.cc')}}</div>
            </div>
            <div class="item1-right">
                <p class="t1" :class="[ Number(increase) < 0 ?'red':'green']">{{curPrice}}</p>
                <p class="t2"><span :class="[ Number(increase) < 0 ?'red':'']">{{updown | toFixed2}}%</span></p>
            </div>
        </div>
        <div class="scroll-box">
            <div class="transaction-box leveragedDeals" v-show="tradeIdx == 0 || tradeIdx == 1">
                <div class="transaction-left">
                    <div class="limit-box" v-if="lang == 'ar'" v-show="tradeIdx == 0"  @click="alertType">
                      <img class="icon" style="margin: 0 .24rem 0 0" src="@/assets/down.png" alt="">
                      <div>{{priceText}}</div>
                    </div>
                    <div class="limit-box" v-else v-show="tradeIdx == 0"  @click="alertType">
                        <div>{{priceText}}</div>
                        <img class="icon" src="@/assets/down.png" alt="">
                    </div>
                    <div class="gg-box" v-if="lang == 'ar'" v-show="tradeIdx == 0" @click="alertGg">
                      <img class="icon" src="@/assets/down.png" alt="">
                      <div class="text">{{$t('hyjy.gg')}}</div>
                      <div>{{ggNum}}x</div>
                    </div>
                    <div class="gg-box" v-else v-show="tradeIdx == 0" @click="alertGg">
                      <div class="text">{{$t('hyjy.gg')}}</div>
                      <div>{{ggNum}}x</div>
                      <img class="icon" src="@/assets/down.png" alt="">
                    </div>
                    <div class="num-wrap" v-show="curPriceType == 0">
                        <div class="input-box xianjia"><input class="input" type="text" v-model="xianjia" @keyup="keyMoney"></div>
                        <div class="num-box">
                            <button class="btn" type="button" @click="priceJian">-</button>
                            <button class="btn" type="button" @click="priceAdd">+</button>
                        </div>
                    </div>
                    <ul class="percent-box" v-show="tradeIdx == 0 && curPriceType == 1">
                        <li class="percent" :class="{active: percentIdx == 0}" @click="percent(0,'0%')"></li>
                        <li class="percent" :class="{active: percentIdx == 1}" @click="percent(1,'25%')"></li>
                        <li class="percent" :class="{active: percentIdx == 2}" @click="percent(2,'50%')"></li>
                        <li class="percent" :class="{active: percentIdx == 3}" @click="percent(3,'75%')"></li>
                        <li class="percent" :class="{active: percentIdx == 4}" @click="percent(4,'100%')"></li>
                    </ul>
                    <div class="percent-text" v-show="tradeIdx == 0 && curPriceType == 1">{{percentVal}} {{currency}}</div>
                    <div class="price-box" v-show="curPriceType == 1 && tradeIdx == 1 "><input class="input" type="text" :placeholder="$t('hyjy.scjg')" disabled readonly></div>
                    <div class="table" :class="{mt32:tradeIdx == 1 }">
                        <div class="table-head">
                            <div class="num-box"><input type="number" class="num number" min="0" :placeholder="$t('hyjy.hand')" v-model="account" onkeyup="this.value=this.value.replace(/\D|^0/g,'')" onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"></div>
                            <!-- <div>{{symbol}}</div> -->
                        </div>
                        <ul class="table-body">
                            <li class="td"><span>{{$t('jghy.sxfl')}}</span> {{deal_rate}}</li>
                        </ul>
                    </div>
                    <div class="cang-box cang-box0" v-show="tradeIdx == 0">
                        <div><span>{{$t('hyjy.ky')}}</span> {{useBalance}} {{moneyUsdt}}</div>
                    </div>
                    <div class="cang-box" :class="{mt31:tradeIdx == 1 }" v-show="tradeIdx == 1">
                        <div><span>{{$t('hyjy.kpc')}}</span> {{useKpk}} {{currency}}</div>
                    </div>
                    <button class="btn-buy" type="button" v-show="tradeIdx == 0" @click="buy(1)">{{$t('hyjy.mrkdkz')}}</button>
                    <button class="btn-buy" type="button" v-show="tradeIdx == 1" @click="buy2(4)">{{$t('hyjy.mrpkkz')}}</button>
                    <div class="cang-box cang-box0" v-show="tradeIdx == 0">
                        <div><span>{{$t('hyjy.ky')}}</span> {{useBalance}} {{moneyUsdt}}</div>
                    </div>
                    <div class="cang-box" :class="{mt31:tradeIdx == 1 }" v-show="tradeIdx == 1">
                        <div><span>{{$t('hyjy.kpd')}}</span> {{useKpd}} {{currency}}</div>
                    </div>
                    <button class="btn-buy btn-sell"  type="button" v-show="tradeIdx == 0" @click="buy(2)">{{$t('hyjy.mckkkd')}}</button>
                    <button class="btn-buy btn-sell"  type="button" v-show="tradeIdx == 1" @click="buy2(3)">{{$t('hyjy.mcpdkd')}}</button>
                </div>
                <div class="transaction-right">
                    <ul class="ul-box">
                        <li class="list">{{$t('hyjy.pk')}}</li>
                        <li class="list">{{$t('hyjy.jg')}}</li>
                        <li class="list list-qty">{{$t('hyjy.sl')}}</li>
                    </ul>
                    <ul class="cont1-box">
                        <li class="cont" v-for="(item,index) in sellArr" :key="index">
                            <div class="item">{{item.title}}</div>
                            <div class="item">{{item.price}}</div>
                            <div class="item item-number">{{item.number}}</div>
                            <div class="scroll" :style="{'width': (((item.number * item.price) /8000)  > 100 ? '100%' : ((item.number * item.price) /8000) + Math.random()*15 + '%')}"></div>
                        </li>
                    </ul>
                    <div class="line"></div>
                    <ul class="cont1-box">
                        <li class="cont cont2" v-for="(item,index) in buyArr" :key="index">
                            <div class="item">{{item.title}}</div>
                            <div class="item">{{item.price}}</div>
                            <div class="item item-number">{{item.number}}</div>
                            <div class="scroll2" :style="{'width': (((item.number * item.price) /8000)  > 100 ? '100%' : ((item.number * item.price) /8000) + Math.random()*15 + '%')}"></div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 持仓 -->
            <div class="chicang-scroll-box" v-show="tradeIdx == 2" @scroll="listenScroll">
                <ul class="chicang-box">
                    <li class="list" v-for="(item,index) in positionList" :key="index">
                        <div class="chicang-head">
                            <ul class="chicang-item-box">
                                <li class="t1">{{item.type_text}}</li>
                                <li class="t2"><span>{{$t('hyjy.ggbs')}}</span> <span class="gg">{{item.multiple}}x</span></li>
                            </ul>
                            <ul class="chicang-item-box">
                                <li class="chicang-item-left">
                                    <p>{{$t('hyjy.ccjg')}}</p>
                                    <p class="price1">{{item.position_price | toFixed4}}</p>
                                </li>
                                <li class="chicang-item-right">
                                    <p>{{$t('hyjy.ccsl')}}</p>
                                    <p class="price2">{{item.position}}</p>
                                </li>
                            </ul>
                            <ul class="chicang-item-box">
                                <li class="chicang-item-left">
                                    <p>{{$t('hyjy.yk')}}</p>
                                    <p class="price1">{{item.profit_loss | toFixed4}}</p>
                                </li>
                                <li class="chicang-item-right">
                                    <p>{{$t('hyjy.ccsj')}}</p>
                                    <p class="price2">{{item.position_time}}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="chicang-body">
                            <ul>
                                <li class="chicang-body-list">
                                    <div class="flex2">
                                        <p class="t1">{{$t('hyjy.zy')}}</p>
                                        <p class="t2">{{item.stop_profit | toFixed4}}</p>
                                    </div>
                                    <div class="tc flex1">
                                        <p class="t1">{{$t('hyjy.zs')}}</p>
                                        <p class="t2">{{item.stop_loss | toFixed4}}</p>
                                    </div>
                                    <div class="tr flex2">
                                        <p class="t1">{{$t('hyjy.zje')}}</p>
                                        <p class="t2">{{item.total | toFixed4}}</p>
                                    </div>
                                </li>
                                <li class="chicang-body-list">
                                    <div class="flex2">
                                        <p class="t1">{{$t('hyjy.bzjl')}}</p>
                                        <p class="t2">{{item.margin | toFixed4}}</p>
                                    </div>
                                    <div class="tc flex1">
                                        <p class="t1">{{$t('hyjy.ss')}}</p>
                                        <p class="t2">{{item.position_a}}</p>
                                    </div>
                                    <div class="tr flex2">
                                        <p class="t1">{{$t('hyjy.kcjg')}}</p>
                                        <p class="t2">{{item.open_price}}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="btn-box">
                            <button type="button" class="btn btn2" @click="jump(item.id,item.position_price.toFixed(4))">{{$t('hyjy.zyzs')}}</button>
                            <button type="button" class="btn" @click="pcAlert(index,item.id,item.type_text,item.position_price.toFixed(4),item.position_a)">{{$t('hyjy.pc')}}</button>
                        </div>
                    </li>
                    <!-- 暂无数据 -->
                    <div class="null-box" v-show="isCcNoData">
                        <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                        <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                        <p class="text">{{$t('zwsj.title')}}</p>
                    </div>
                </ul>
            </div>
            <div class="transaction-foot leveragedDeals" v-show="tradeIdx == 0 || tradeIdx == 1">
                <ul class="tab-box">
                    <li class="tab active">{{$t('hyjy.dqwt')}}</li>
                    <li><a @click="all"><img class="btn-all" src="@/assets/all.png" alt=""><span>{{$t('hyjy.qb')}}</span></a></li>
                </ul>
                <ul class="cont-box leveragedDeals" v-show="tabIdx == 0">
                    <li class="list" v-for="(item,index) in wetTuoData" :key="index">
                        <div class="list-head">
                            <div class="buy" v-if="item.mark == 1">{{$t('hyjy.mai')}}</div>
                            <div class="buy sell" v-if="item.mark == 2">{{$t('hyjy.mai')}}</div>
                            <div class="type">{{item.currency}} <span>/USDT</span></div>
                            <div class="date">{{item.time | subStr1}}</div>
                            <div class="time">{{item.time | subStr2}}</div>
                            <div class="status" v-if="item.status == 2">{{ycd}}</div>
                            <div class="status" v-else-if="item.status == 1">{{ywc}}</div>
                            <div class="btn-cancle" v-else @click="cancelOrder(index,item.id)">{{cd}}</div>
                        </div>
                        <div class="list-body">
                            <div class="list-item">
                                <div class="list-item-left">
                                    <div><span>{{wtzl}}</span> {{item.amount}}</div>
                                </div>
                                <div class="list-item-right">
                                    <div><span>{{wtjg}}</span> {{item.price}}</div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- 暂无数据 -->
                <div class="null-box" v-show="isNoData">
                    <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                    <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                    <p class="text">{{$t('zwsj.title')}}</p>
                </div>
            </div>
        </div>
        <!-- 平仓弹窗 -->
        <div class="alert-pc" v-show="isPc">
            <ul class="alert-pc-head">
                <li><span class="t1">{{type_text}}</span></li>
                <li class="cancle" @click="cancle">{{$t('hyjy.qx')}}</li>
            </ul>
            <ul class="input-wrap">
                <li class="input-box">
                    <div><input class="input" type="number" v-model="position_price" disabled readonly></div>
                    <div class="t1">{{$t('hyjy.xj')}}</div>
                </li>
                <li class="input-box">
                    <div><input class="input" type="number" v-model="position" disabled readonly></div>
                    <div class="t2">{{$t('hyjy.ss')}}</div>
                </li>
            </ul>
            <button type="button" class="btn btn-bg" @click="pingCang(ccIdx,ccId)">{{$t('hyjy.pc')}}</button>
        </div>
        <!-- 调整保证金弹窗 -->
        <div class="alert-pc alert-bzj" v-show="isBzj">
            <ul class="alert-pc-head">
                <li>{{$t('hyjy.tzbzj')}}</li>
                <li class="cancle" @click="cancle">{{$t('hyjy.qx')}}</li>
            </ul>
            <ul class="tab-box">
                <li class="tab" :class="{active: bzjIdx == '0'}" @click="bzj('0')">{{$t('hyjy.zjbzj')}}</li>
                <li class="tab" :class="{active: bzjIdx == '1'}" @click="bzj('1')">{{$t('hyjy.jsbzj')}}</li>
            </ul>
            <ul class="ul-box">
                <li class="list">
                    <p class="t1">{{$t('hyjy.yxhy')}}</p>
                    <p class="t2">{{$t('hyjy.tyhy')}}</p>
                </li>
                <li class="list">
                    <p class="t1">{{$t('hyjy.ccz')}}</p>
                    <p class="t2">100</p>
                </li>
                <li class="list">
                    <p class="t1">{{$t('hyjy.cwbzjt')}}</p>
                    <p class="t2">0.0012</p>
                </li>
                <li class="list">
                    <p class="t1">{{$t('hyjy.zdzjbzj')}}</p>
                    <div class="t2 zd">
                        <p>0.46687</p>
                        <p class="all">{{$t('hyjy.qb')}}</p>
                    </div>
                </li>
                <li class="list">
                    <p class="t1">{{$t('hyjy.zjbzjt')}}</p>
                    <div class="t2 num-box">
                        <div>{{$t('hyjy.sl')}}</div>
                        <div class="bzj-input-box"><input class="input" type="number"></div>
                    </div>
                </li>
            </ul>
            <button type="button" class="btn">{{$t('hyjy.qr')}}</button>
        </div>
        <!-- 调整杠杆弹窗 -->
        <div class="alert-gg" v-show="isGg">
            <ul class="alert-gg-head">
                <li>{{$t('hyjy.tzgg')}}</li>
                <li class="cancle" @click="cancle">{{$t('hyjy.qx')}}</li>
            </ul>
            <div class="gg-box">
                <div class="btn" @click="jian">-</div>
                <div class="input-box">
                    <input class="input" type="number" min="1" v-model="ggNum" onkeyup="this.value=this.value.replace(/\D|^0/g,'')" onafterpaste="this.value=this.value.replace(/\D|^0/g,'')">
                    <div class="dw">x</div>
                </div>
                <div class="btn" @click="add">+</div>
            </div>
            <div class="progess-box">
                <ul class="progess-ul">
                    <li class="progess" :class="{active: progessIdx == '0'}" @click="progess('0')">
                        <div class="progess-tips">1x</div>
                        <div class="progess-text">1x</div>
                    </li>
                    <li class="progess" :class="{active: progessIdx == '1'}" @click="progess('1')">
                        <div class="progess-tips">20x</div>
                        <div class="progess-text">20x</div>
                    </li>
                    <li class="progess" :class="{active: progessIdx == '2'}" @click="progess('2')">
                        <div class="progess-tips">40x</div>
                        <div class="progess-text">40x</div>
                    </li>
                    <li class="progess" :class="{active: progessIdx == '3'}" @click="progess('3')">
                        <div class="progess-tips">60x</div>
                        <div class="progess-text">60x</div>
                    </li>
                    <li class="progess" :class="{active: progessIdx == '4'}" @click="progess('4')">
                        <div class="progess-tips">80x</div>
                        <div class="progess-text">80x</div>
                    </li>
                    <li class="progess" :class="{active: progessIdx == '5'}" @click="progess('5')">
                        <div class="progess-tips">100x</div>
                        <div class="progess-text t6">100x</div>
                    </li>
                </ul>
            </div>
            <button type="button" class="btn-sure btn-bg" @click="progessSure">{{$t('hyjy.qr')}}</button>
        </div>
        <!-- 左侧弹框  -->
        <div class="alert-left" v-show="isLeftShow">
            <ul class="tab-box">
                <li class="tab" :class="{active: tabLeftIdx == 0}" @click="tabLeft(0)">{{$t('hyjy.zx')}}</li>
                <li class="tab" :class="{active: tabLeftIdx == 1}" @click="tabLeft(1)">USDT</li>
            </ul>
            <ul class="ul-box">
                <li class="list" :class="{active: item.symbol == symbol}" v-for="(item,index) in leftData" :key="item.id" @click="leftClick(index,item.name,item.symbol,item.type)">
                    <div class="list-box">
                        <div class="t1">{{item.name}}/<span>USDT</span></div>
                        <div class="price" :class="{green: item.change > 0}">{{item.new_price | toFixed4}}</div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 限价0，市价1弹窗 -->
        <div class="alert-box currencyTrading" v-show="isShow">
            <div class="alert-item xj" :class="{active: curPriceType == 0}" @click="select(priceType[0],0)">{{priceType[0]}}</div>
            <div class="alert-item" :class="{active: curPriceType == 1}" @click="select(priceType[1],1)">{{priceType[1]}}</div>
            <div class="alert-item btn-cancle" @click="cancle">{{$t('hyjy.qx')}}</div>
        </div>
        <div class="mask" v-show="isMask" @click="cancle"></div>
        <nav-bar :navName="'contractTransaction'"></nav-bar>
    </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
let that = this;
export default {
    name: 'perpetualContract',
    data () {
        return {
            lang: 'zh',
            isShow: false,
            isLeftShow: false,
            isNoData: false,
            isCcNoData: false,//持仓数据判断
            isPc: false,//平仓弹窗
            isBzj: false,//调整保证金弹窗
            isGg: false,//杠杆弹窗
            isMask: false,
            tradeIdx: 0,
            tabIdx: '0',
            bzjIdx: '0',
            tabLeftIdx: 1,
            leftIdx: 0,
            progessIdx: '0',
            priceText: '',
            currency: 'BTC',
            curPriceType: 1,//0限价1市价
            curPrice: '',
            account:'',
            xianjia: '',
            useBalance: '',//账户余额
            moneyUnit: '',//卖出币种单位
            moneyUsdt: '',//买入币中单位
            lot: '',
            lots: '',
            positions: '',//持仓
            symbol: '',
            mark: 1,
            wetTuoData: [],//委托数据
            sellArr: [],//右侧前五条数据
            buyArr: [],//右侧后五条数据
            priceType: [],
            leftData: [],
            positionList: [],//持仓记录
            price: 1,
            ggNum: 1,
            ccId: '',//持仓Id
            ccIdx: '',//持仓Idx
            type_text: '',//持仓名称
            position_price:'',//持仓价格
            position: '',//持仓数量,
            newprice: '',
            updown: '',
            useKpk: '',
            useKpd: '',
            curDataLength: 10,
            isScroll: false,//是否滚动到底部
            page: 1,
            timer: null,
            timer2: null,
            timer3: null,
            mai: '',
            sell: '',
            wtzl: '',
            wtjg: '',
            ycd: '',
            ywc: '',
            cd: '',
            ccjg: '',
            ccsl: '',
            yk: '',
            ccsj: '',
            zy: '',
            zs: '',
            zje: '',
            bzjl: '',
            kcs: '',
            kcjg: '',
            zyzs: '',
            pc: '',
            ss: '',
            increase: '',
            currencyList: [],
            percentIdx: 0,
            percentVal: '0%',
            deal_rate: '',
            max_cnt: 0,
            price_type2: [],
            websock: null,
            theme: false,
            lang: 'en'
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
      this.lang = localStorage.getItem('language') || 'en';
      this.theme = JSON.parse(localStorage.getItem('theme'))
      this.tradeIdx = this.$route.query.tradeIdx || 0;
      this.currency = this.$route.query.currency || 'BTC';
      this.symbol = this.$route.query.symbol || '';
      this.leftIdx = this.$route.query.leftIdx || 1;
      this.lang = localStorage.getItem('language') || 'en';
      this.mai = this.$t('hyjy.mai');
      this.sell = this.$t('hyjy.sell');
      this.wtzl = this.$t('hyjy.wtzl');
      this.wtjg = this.$t('hyjy.wtjg');
      this.ywc = this.$t('hyjy.ywc');
      this.ycd = this.$t('hyjy.ycd');
      this.cd = this.$t('hyjy.cd');
      this.ccjg = this.$t('hyjy.ccjg');
      this.ccsl = this.$t('hyjy.ccsl');
      this.yk = this.$t('hyjy.yk');
      this.ccsj = this.$t('hyjy.ccsl');
      this.zy = this.$t('hyjy.zy');
      this.zs = this.$t('hyjy.zs');
      this.zje = this.$t('hyjy.zje');
      this.bzjl = this.$t('hyjy.bzjl');
      this.kcs = this.$t('hyjy.kcs');
      this.kcjg = this.$t('hyjy.kcjg');
      this.zyzs = this.$t('hyjy.zyzs');
      this.pc = this.$t('hyjy.pc');
      this.ss = this.$t('hyjy.ss');
      this.price_type2 = [this.$t('hyjy.xjwt'),this.$t('hyjy.sjwt')];
    },
    mounted() {
      let that = this;
        that.priceText = this.price_type2[1];
        that.priceType = [this.$t('hyjy.xjwt'),this.$t('hyjy.sjwt')];
        let params = {
            id: 1
        }
        this.$ajax.get('/web/getmarketList',{params}).then((res) => {
            let resData = res.data.data;
            if(that.symbol == '' || that.symbol == null){
            that.currency = resData[0].currency;
            that.symbol = resData[0].symbol;
            that.getCurrency();//获取左侧币种
            that.getCurPrice();//获取当前价格
            that.getAsset();//请求可用余额
            that.getPositionCount();
            that.getWeiTuo();
            that.getmarketList(); //获取币种
            that.initWebSocket();
            if(that.tradeIdx == 2){
                that.getPositionList();
            }
            that.timer = setInterval(() => {
                that.getCurrency();
                that.getPositionCount();
            }, 2000);
            that.timer2 = setInterval(() => {
                that.getWeiTuo();
            }, 2000);
        }else{
            that.getCurrency();//获取左侧币种
            that.getCurPrice();//获取当前价格
            that.getAsset();//请求可用余额
            that.getPositionCount();
            that.getWeiTuo();
            that.getmarketList(); //获取币种
            that.initWebSocket();
            if(that.tradeIdx == 2){
                that.getPositionList();
            }
            that.timer = setInterval(() => {
                that.getCurrency();
                that.getPositionCount();
            }, 2000);
            that.timer2 = setInterval(() => {
                that.getWeiTuo();
            }, 2000);
        }
        }).catch(function(err){
            console.log(err)
        })
    },
    methods: {
        percent(idx,percent){
            this.percentIdx = idx;
            this.percentVal = percent;
            this.account = parseInt(Math.floor((percent.split('%')[0] / 100  *  this.max_cnt).toFixed(4)));
        },
        getmarketList(){
            let that = this;
            let params = {
              id: that.tabLeftIdx
            }
           this.$ajax.get('/web/getmarketList',{params}).then((res) => {
                let resData = res.data.data;
                let msg = resData[that.leftIdx];
                that.leftData = resData;
                that.currencyList = [];
                for (var curr in resData){
                    that.currencyList[that.leftData[curr].currency_name.toLowerCase()] = [that.leftData[curr].icon,that.leftData[curr].symbol] ;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        initWebSocket(){ //初始化weosocket
            const wsuri = this.socket_url;
            this.websock = new WebSocket(wsuri);
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
        },
        websocketonopen(){ //连接建立之后执行send方法发送数据

        },
        websocketonerror(){//连接建立失败重连
            this.initWebSocket();
        },
        websocketonmessage(e){ //数据接收
            if(JSON.parse(e.data).action == "marketprice"){
                let currency = this.currency.toLowerCase();
                let msg = JSON.parse(e.data).content;
                let daymarket = msg[currency];
                this.curPrice = daymarket.now_price;
                this.increase = daymarket.change;
                this.updown = daymarket.change;
                let keyArr = [];
                for(var x in this.currencyList){
                    for(var y in this.leftData){
                      if(!msg[x]) return;
                      if(msg[x].currency_name == this.leftData[y].currency_name){
                          this.leftData[y]['new_price'] = msg[x].now_price;
                          this.leftData[y]['change'] = msg[x].change;
                          keyArr.push(this.leftData[y]);
                          break;
                      }
                    }
                }
                this.leftData = keyArr;
            }
        },
        websocketsend(Data){//数据发送
            this.websock.send(Data);
        },
        websocketclose(e){  //关闭
            // console.log('断开连接',e);
        },
        getCurPrice(){
            let that = this;
            let params = {
                id: 1,
                symbol: that.symbol
            }
            this.$ajax.get('/web/getmarketList',{params}).then((res) => {
                let resData = res.data.data;
                that.newprice = resData[0].new_price;
                that.xianjia =  resData[0].new_price;
            }).catch(function(err){
                console.log(err)
            })
        },
        getCurrency(){
            let that = this;
            let params = {
                currency: that.currency,
                type: 2
            }
            this.$ajax.get('/web/getCurrencyPriceAndIncrease',{params}).then((res) => {
                let resData = res.data.data;
                let xianjiaArr = resData.value.split(",");
                if(that.symbol == '' || that.symbol == null){
                    that.currency = resData.price[0].name;
                    that.symbol = resData.price[0].symbol;
                }
                var str = resData.deal;
                var value = resData.value;
                if (typeof (str) === 'object') {
                    value = str.value
                    str = str.deal
                }
                var arr = str.split(",");
                var start = 1;
                var len = 5;
                var sell = [];
                for (; ; start += 2) {
                    sell.push({
                        title: len,
                        price: that.toFixed(arr[start]),
                        number: that.toFixed(arr[start + 1])
                    });
                    len--;
                    if (len == 0) break;
                }
                that.sellArr = sell;
                start = 11;
                var len = 1;
                var buy = [];
                for (; ; start += 2) {
                    buy.push({
                        title: len,
                        price: that.toFixed(arr[start]),
                        number: that.toFixed(arr[start + 1])
                    });
                    len++;
                    if (len == 6) break;
                }
                that.buyArr =  buy;
            }).catch(function(err){
                console.log(err)
            })
        },
        getAsset(){
            let that = this;
            let params = {
              type:2,
              currency: that.currency,
              multiple: that.ggNum
            }
            this.$ajax.get('/web/getInfo',{params}).then((res) => {
                let resData = res.data.data;
                var lotText = String(this.$t('hyjy.hand'));
                that.useBalance =  (Number(resData.wallet.usdt)).toFixed(4);
                that.positions =  (Number(resData.wallet.positions)).toFixed(4);
                that.moneyUsdt = resData.usdt;
                that.moneyUnit = resData.unit;
                that.lot = resData.lot;
                that.max_cnt = resData.max_cnt;
                if(that.lang == 'ar'){
                  $('.number').attr('placeholder',resData.unit + ' ' + resData.lot + ' ' + '= ' + 'لوت ' + '1');
                }else{
                  $('.number').attr('placeholder',lotText + ' ' + resData.lot + resData.unit);
                }
                that.deal_rate = resData.deal_rate + '%'
                that.account = parseInt(Math.floor((that.percentVal.split('%')[0] / 100  * resData.max_cnt).toFixed(4))) || '';
            }).catch(function(err){
                console.log(err)
            })
        },
        getPositionCount(){//查询合约可平仓总数
            let that = this;
            let params = {
                currency: that.currency
            }
            this.$ajax.get('/web/getPositionCount',{params}).then((res) => {
                let resData = res.data.data;
                that.useKpk =  (Number(resData[4].position)).toFixed(4);
                that.useKpd =  (Number(resData[3].position)).toFixed(4);
            }).catch(function(err){
                console.log(err)
            })
        },
        getWeiTuo(){
            let that = this;
            let params = {
                currency: that.currency,
                type: 2,
                wt: 13,
                limit: 10,
                page: 1
            }
           this.$ajax.get('/web/getWeiTuo',{params}).then((res) => {
                let resData = res.data.data;
                if(resData.list.length > 0){
                    that.wetTuoData = resData.list;
                    that.isNoData = false;
                }else{
                    clearInterval(that.timer2);
                    that.timer2 = null;
                    that.wetTuoData = [];
                    that.isNoData = true;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        getPositionList(){//持仓记录
            let that = this;
            let params = {
                currency: that.currency,
                is_pl_r: 1,
                page: that.page
            }
           this.$ajax.get('/web/getPositionList',{params}).then((res) => {
                let resData = res.data.data;
                if(resData.list.length > 0){
                    if(that.isScroll){
                        that.positionList = that.positionList.concat(resData.list);
                    }else{
                        that.positionList = resData.list;
                    }
                    that.curDataLength = resData.list.length;
                }else{
                    clearInterval(that.timer3)
                    that.timer3 = null;
                    that.curDataLength = resData.list.length;
                }
                if(that.positionList.length > 0){
                    that.isCcNoData = false;
                }else{
                    that.isCcNoData = true;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength > 0){
                    this.isScroll = true
                    this.page ++;
                    this.getPositionList();
                }else{
                    this.isScroll = false
                }
            }
        },
        buy(id){
            let that = this;
            if(that.xianjia == '' || that.xianjia <= 0){
                this.$toast.center(this.$t('tipsNew.qsrss'));
                return false;
            }
            if(that.account == '' || that.account <= 0){
                this.$toast.center(this.$t('tipsNew.qsrss'));
                return false;
            }else if(that.account < 1 ){
                this.$toast.center(this.$t('tipsNew.zdss') + 1);
                return false;
            }
            let params = {
                multiple: that.ggNum,
                price: that.xianjia,
                amount: that.account,
                price_type: that.curPriceType,
                mark: id,
                currency: that.currency,
                deal_type: 2
            }
            that.account = '';
            this.$ajax.post('/web/createOrder',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                  that.account = '';
                  that.percentIdx = 0;
                  that.percentVal = '0%';
                  that.isScroll = false;
                  that.page = 1;
                  that.account = '';
                  that.ggNum = 1;
                  that.$toast.center(resData.message);
                  that.getAsset();
                  that.getPositionCount();
                  that.getWeiTuo();
                }else{
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        buy2(id){//平仓
            let that = this;
            if(that.account == '' || that.account <= 0){
                this.$toast.center(this.$t('tipsNew.qsrss'));
                return false;
            }else if(that.account < 1 ){
                this.$toast.center(this.$t('tipsNew.zdss') + 1);
                return false;
            }
            let params = {
                amount: that.account,
                mark: id,
                currency: that.currency,
                layer_loading: true
            }
            that.account = '';
            this.$ajax.post('/web/closePositionCount',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    that.$toast.center(resData.message);
                    that.account = '';
                    that.isScroll = false;
                    that.page = 1;
                    that.getAsset();
                    this.getPositionCount();
                    that.getWeiTuo();
                }else{
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        pingCang(idx,id){//平仓
            let that = this;
            let params = {
              id: id
            }
            this.$ajax.post('/web/closePosition',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    that.$toast.center(resData.message);
                    that.isPc = false;
                    that.isMask = false;
                    that.positionList.splice(idx,1)
                    that.getPositionList();
                }else{
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        priceJian(){
            var num = Number(this.xianjia);
            num = (num * 10 * 10 * 10 * 10);
            num -= 1;
            num = ((Number(num)) / 10000).toFixed(4)
            if (num <= 0) {
                num = 0;
            }
            this.xianjia = num;
        },
        priceAdd(){
            var num = Number(this.xianjia);
            num = (num * 10 * 10 * 10 * 10);
            num += 1;
            num = ((Number(num)) / 10000).toFixed(4)
            this.xianjia = num;
        },
        leftClick(idx,name,symbol,type){//左侧币种选择
            this.leftIdx = idx;
            this.currency = name;
            this.symbol = symbol;
            this.isLeftShow = false;
            this.isMask = false;
            this.percentIdx = 0;
            this.percentVal = '0%';
            this.account = '';
            this.getCurrency();
            this.getCurPrice();
            this.getWeiTuo();
            this.getAsset();
            this.getPositionCount();
            if(type != 1){
              this.$router.push({ path: '/preciousMetal', query: { symbol: symbol } })
            }
        },
        kline(symbol){
            this.$router.push({ path: '/kline', query: { symbol: symbol,jy: 2,leftIdx: this.leftIdx } })
        },
        toFixed(v) {
            return parseFloat(v).toFixed(4)
        },
        alertType(){
            this.isShow = true;
            this.isMask = true
        },
        select(obj,curPriType){
            this.priceText = obj;
            this.curPriceType = curPriType;
            this.isShow = false;
            this.isMask = false;
        },
        progessSure(){//杠杆确认
            if(this.ggNum <= 0){
              this.ggNum = 1
            }
            this.isGg = false;
            this.isMask = false;
        },
        leftShow(){
            this.isLeftShow = true;
            this.isMask = true;
        },
        trade(idx){
            this.tradeIdx = idx;
            this.curPriceType = 1;
            this.priceText = this.price_type2[this.curPriceType];
            this.account = '';
            this.percentIdx = 0;
            this.percentVal = '0%';
            this.getCurrency();
            this.getAsset();
            this.getPositionCount();
            this.getWeiTuo();
            this.getPositionList();
            if(idx == 2){
                this.timer3 = setInterval(() => {
                    this.getPositionList();
                }, 2000);
            }else{
                clearInterval(this.timer3);
                this.timer3 = null;
            }
        },
        tab(idx){
            this.tabIdx = idx;
        },
        tabLeft(idx){
            this.leftData = [];
            this.tabLeftIdx = idx;
            this.getmarketList();
        },
        bzj(idx){
            this.bzjIdx = idx;
        },
        pcAlert(idx,id,type_text,position_price,position){
            this.isMask = true;
            this.isPc = true;
            this.ccIdx = idx;
            this.ccId = id;
            this.type_text = type_text;
            this.position_price = position_price;
            this.position = position
        },
        bzjAlert(){
            this.isMask = true;
            this.isBzj = true;
        },
        progess(idx){
            this.progessIdx = idx;
            if(idx == 0){
                this.ggNum = 1
            }else if(idx == 1){
                this.ggNum = 20
            }else if(idx == 2){
                this.ggNum = 40
            }else if(idx == 3){
                this.ggNum = 60
            }else if(idx == 4){
                this.ggNum = 80
            }else{
                this.ggNum = 100
            }
        },
        all(){
          this.$router.push({ path: '/delegateList', query: { tradeIdx: this.tradeIdx } })
        },
        alertGg(){
            this.isMask = true;
            this.isGg = true;
        },
        jian(){
            if(this.ggNum > 1){
                this.ggNum --;
            }
        },
        add(){
            if(this.ggNum < 100){
                this.ggNum ++;
            }
        },
        jump(id,price){
          this.$router.push({ path: '/profitLoss', query: { tradeIdx: 2,id: id,price: price } })
        },
        link(id){
          if(id == 1){
            this.$router.push({ path: '/contractTransaction', query: { symbol: this.symbol,jy: 2,leftIdx: this.leftIdx } })
          }else if(id == 2){
            this.$router.push({ path: '/currencyTrading', query: { symbol: this.symbol,jy: 2,leftIdx: this.leftIdx } })
          }
        },
        cancelOrder(idx,id){//撤单
            var that = this;
            let params = {id:id}
            that.wetTuoData.splice(idx,1);
            this.$ajax.post('/web/orderCancel',params).then((res) => {
              let resData = res.data;
              that.$toast.center(resData.message);
              that.getWeiTuo();
            }).catch(function(err){
                console.log(err)
            })
        },
        cancle(){
            this.isShow = false;
            this.isLeftShow = false;
            this.isPc = false;
            this.isBzj = false;
            this.isGg = false;
            this.isMask = false
        },
        keyMoney(){
          this.xianjia = this.xianjia.replace(/[^\d.]/g, "");  //仅保留数字和"."
          this.xianjia = this.xianjia.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
          this.xianjia = this.xianjia.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
          this.xianjia = this.xianjia.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
          if (this.xianjia.indexOf(".") < 0 && this.xianjia != "") { //首位是0的话去掉
              this.xianjia = parseFloat(this.xianjia);
          }
        },
    },
    filters:{
        subStr1(val){
            return val.substring(5, 10);
        },
        subStr2(val){
            return val.substring(11, 19);
        }
    },
    watch: {
        ggNum(){
            if(this.ggNum > 100){
                this.ggNum = 100
            }
            this.getAsset()
        }
    },
    beforeDestroy(){
        clearInterval(this.timer);
        clearInterval(this.timer2);
        clearInterval(this.timer3);
        this.timer = null;
        this.timer2 = null;
        this.timer3 = null;
        this.websock.close(); //离开路由之后断开websocket连接
    },
    components:{
        navBar,
    }
}
</script>
<style scoped>
    .scroll-box{
        position: absolute;
        bottom: 2.1rem;
        top: 4.74rem;
        width: 100%;
        background: #fafafa;
        overflow-y: scroll;
    }
    .chicang-scroll-box{
        position: fixed;
        top: 4.5rem;
        bottom: 1.65rem;
        width: 100%;
        height: auto;
        overflow-y: auto;
    }
    .head-tab-box{
        position: fixed;
        top: 0;
        width: 100%;
        padding: .24rem 0 .3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f7f7f7;
    }
    .head-tab-box .tab{
        /* width: 86px; */
        padding: 0 .24rem;
        height: .75rem;
        color: #515151;
        font-size: .42rem;
        line-height: .75rem;
        background: #e2e2e2;
        text-align: center;
    }
    .head-tab-box .tab.active{
        color: #fff;
        background: #218adc;
    }
    .head-tab-box .tab1{
        border-radius: .6rem 0 0 .6rem;
    }
    .head-tab-box .tab2{
        border-radius: 0 .6rem .6rem 0;
    }
    .transaction-head{
        position: fixed;
        top: 1.26rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 1.2rem;
        padding: 0 .48rem 0 .36rem;
        color: #000;
        font-size: .48rem;
        line-height: 1.2rem;
        background: #f7f7f7;
        box-sizing: border-box;
    }
    .transaction-head .icon{
        width: .54rem;
        height: .54rem;
    }
    .transaction-head .text{
        flex: 1;
        padding: 0 .54rem;
    }
    .item1-box{
        position: fixed;
        top: 2.25rem;
        width: 100%;
        display: flex;
        align-items: center;
        padding: .72rem .36rem .12rem;
        background: #f7f7f7;
        box-sizing: border-box;
    }
    .item1-box .tab-box{
        display: flex;
        flex: 1;
        justify-content: space-between;
        align-items: center;
    }
    .item1-box .tab-box .tab{
        position: relative;
        color: #7f7f7f;
        font-size: .42rem;
    }
    .item1-box .tab-box .tab.active{
        color: #000;
        font-size: .4rem;
    }
    .item1-box .tab-box .tab.active::after{
        position: absolute;
        left: 50%;
        bottom: -.18rem;
        content: '';
        width: .6rem;
        height: 2px;
        transform: translateX(-50%);
        background: #218adc;
    }
    .item1-box .item1-right{
        padding-left: 1.5rem;
        text-align: right;
    }
    .item1-box .item1-right .t1{
        color: #009962;
        font-weight: bold;
    }
    .item1-box .item1-right .t2{
        margin-top: .18rem;
        color: #7f7f7f;
        font-size: .36rem;
    }
    .item1-box .item1-right .t2 span{
        display: inline-block;
        padding: .06rem .12rem;
        color: #fff;
        border-radius: .12rem;
        background: #00c483;
    }
    .item1-box .item1-right .t2 .red{
        color: #fff!important;
        background: #d85656;
    }
    .transaction-box{
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        background: #fff;
    }
    .transaction-box .transaction-left{
        flex: 1;
        padding: .42rem .42rem .66rem .24rem;
    }
    .transaction-box .transaction-left .limit-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .15rem .12rem;
        color: #7f7f7f;
        border: 1px solid #d7d7d7;
        border-radius: .12rem;
    }
    .transaction-box .transaction-left .gg-box{
        display: flex;
        align-items: center;
        margin-top: .2rem;
        padding: .15rem .12rem;
        color: #7f7f7f;
        border: 1px solid #d7d7d7;
        border-radius: .12rem;
    }
    .transaction-box .transaction-left .gg-box .text{
        flex: 1;
    }
    .transaction-box .transaction-left .limit-box .icon,.transaction-box .transaction-left .gg-box .icon{
        margin-left: .24rem;
        width: .36rem;
        height: .3rem;
    }
    .transaction-box .transaction-left .num-wrap{
        display: flex;
        align-items: center;
        padding: .18rem 0;
    }
    .transaction-box .transaction-left .input-box{
        flex: 1;
        border-right: 1px solid #ddd;
    }
    .transaction-box .transaction-left .input{
        width: 100%;
        height: .9rem;
        padding: 0 .12rem;
        color: #000;
        line-height: .9rem;
    }
    .transaction-box .transaction-left .num-box{
        display: flex;
        align-items: center;
    }
    .transaction-box .transaction-left .num-wrap .btn{
        display: block;
        width: .9rem;
        height: .9rem;
        color: #969696;
        font-size: .48rem;
        font-weight: bold;
        line-height: .9rem;
        background: #fff;
    }
    .transaction-box .transaction-left .price{
        color: #7f7f7f;
    }
    .transaction-box .transaction-left .price-box{
        margin: .12rem 0 0;
    }
    .transaction-box .transaction-left .price-box .input{
        height: 1.14rem;
        color: #666;
        line-height: 1.14rem;
        background: #eff4f4;
        text-align: center;
    }
    .transaction-box .transaction-left .table .table-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .24rem .12rem;
        color: #a3a3a3;
        font-size: .36rem;
        border: 1px solid #d7d7d7;
        border-radius: .12rem;
    }
    .transaction-box .transaction-left .table .table-head .num-box{
        flex: 1;
    }
    .transaction-box .transaction-left .table .table-head .num-box .num{
        width: 100%;
    }
    .transaction-box .transaction-left .table .table-body{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .transaction-box .transaction-left .table .td{
        width: 100%;
        padding: .18rem 0 0;
        color: #666;
        font-size: .36rem;
        border-right: 1px solid #d7d7d7;
    }
    .transaction-box .transaction-left .table .td:last-child{
        border-right: none;
    }
    .transaction-box .transaction-left .cang-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #666;
        font-size: .36rem;
    }
    .transaction-box .transaction-left .cang-box0{
        display: block;
        margin-top: .3rem;
    }
    .transaction-box .transaction-left .trade{
        margin-top: 1.08rem;
        color: #7f7f7f;
    }
    .transaction-box .transaction-left .btn-buy{
        display: block;
        width: 100%;
        height: 1.1rem;
        margin-top: .24rem;
        color: #fff;
        font-size: .36rem;
        border-radius: .12rem;
        background: #00c483;
        text-align: center;
    }
    .transaction-box .transaction-left .btn-sell{
        background: #d85656;
    }
    .transaction-box .transaction-right{
        flex: 1;
    }
    .transaction-box .transaction-right .ul-box{
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        padding-top: .42rem;
        color: #7f7f7f;
    }
    .transaction-box .transaction-right .ul-box .list{
        flex: 1;
        text-align: center;
    }
    .transaction-box .transaction-right .ul-box .list-qty{
        flex: 1.5;
    }
    .transaction-box .transaction-right .cont1-box .cont{
        position: relative;
        z-index: 2;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: .3rem;
        font-size: .36rem;
    }
    .transaction-box .transaction-right .cont1-box .cont2 .item{
        color: #00c483;
    }
    .transaction-box .transaction-right .cont1-box .scroll{
        position: absolute;
        right: 0;
        z-index: -1;
        width: 20%;
        height: .9rem;
        background: #fff0f5;
        transition: all 1s ease-in;
    }
    .transaction-box .transaction-right .cont1-box .scroll2{
        position: absolute;
        right: 0;
        z-index: -1;
        width: 20%;
        height: .9rem;
        background: #e9fff6;
        transition: all 1s ease-in;
    }
    .transaction-box .transaction-right .cont1-box .item{
        flex: 1;
        color: #d85656;
        text-align: center;
    }
    .transaction-box .transaction-right .cont1-box .item-number{
        flex: 1.5;
    }
    .transaction-box .transaction-right .line{
        margin: .42rem 0 0;
        height: 1px;
        background: #f0f0f0;
    }
    .transaction-foot{
        margin-top: .24rem;
        padding: 0 .24rem .9rem .42rem;
        background: #fff;
    }
    .transaction-foot .tab-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .48rem 0 .18rem;
        color: #b5b5b5;
        font-size: .45rem;
    }
    .transaction-foot .tab-box .active{
        color: #000;
        font-size: .48rem;
    }
    .transaction-foot .tab-box .btn-all{
        width: .48rem;
        height: .48rem;
        margin-right: .24rem;
        vertical-align: -2px;
    }
    .transaction-foot .cont-box .list{
        margin-top: .6rem;
    }
    .transaction-foot .cont-box .list .list-head{
        display: flex;
        align-items: center;
    }
    .transaction-foot .cont-box .list .buy{
        padding: 1px .12rem;
        color: #fff;
        font-size: .36rem;
        border-radius: .18rem;
        background: #00c483;
    }
    .transaction-foot .cont-box .list .sell{
        background: #d85656;
    }
    .transaction-foot .cont-box .list .type{
        padding: 0 .3rem 0 .24rem;
        color: #000;
        font-weight: bold;
    }
    .transaction-foot .cont-box .list .type span{
        color: #b5b5b5;
        font-size: .39rem;
        font-weight: normal;
    }
    .transaction-foot .cont-box .list .date{
        color: #b5b5b5;
    }
    .transaction-foot .cont-box .list .time{
        flex: 1;
        padding-left: .3rem;
        color: #b5b5b5;
    }
    .transaction-foot .cont-box .list .btn-cancle{
        padding: .12rem .18rem;
        color: #218adc;
        font-size: .36rem;
        border: 1px solid #218adc;
        border-radius: .12rem;
    }
    .transaction-foot .cont-box .list .status{
        color: #b5b5b5;
    }
    .transaction-foot .cont-box .list .list-body .list-item{
        margin-top: .3rem;
        color: #7f7f7f;
    }
    .transaction-foot .cont-box .list .list-body .list-item-right{
        flex: 1;
        margin-top: .3rem;
    }
    .transaction-foot .cont-box .list .list-body .t2{
        margin-top: .3rem;
    }
    .transaction-foot .cont-box .cont1{
        padding: .48rem .36rem;
        color: #666;
        background: #fafafa;
        border-bottom: 1px solid #e0e0e0;
    }
    .transaction-foot .cont-box .cont2{
        padding: .36rem .36rem 0;
        background: #fafafa;
    }
    .transaction-foot .cont-box .cont2 .ul-box .li{
        display: flex;
        align-items: center;
        padding-bottom: .54rem;
        color: #666;
    }
    .transaction-foot .cont-box .cont2 .ul-box .t2{
        flex: 1;
        text-align: right;
    }
    .chicang-box{
        background: #f7f7f7;
    }
    .chicang-box .list{
        padding: .54rem .54rem .45rem .36rem;
        margin-bottom: .3rem;
        background: #fff;
    }
    .chicang-box .chicang-head{
        padding-bottom: .3rem;
        border-bottom: 1px solid #e0e0e0;
    }
    .chicang-box .chicang-head .chicang-item-box{
        display: flex;
        align-items: center;
        color: #7f7f7f;
    }
    .chicang-box .chicang-head .chicang-item-box .t1{
        flex: 1;
        color: #000;
        font-size: .42rem;
        font-weight: bold;
    }
    .chicang-box .chicang-head .chicang-item-box .t2{
        flex: 1;
        padding-left: .18rem;
    }
    .chicang-box .chicang-head .chicang-item-box .t2 .gg{
        color: #009962;
        font-weight: bold;
    }
    .chicang-box .chicang-head .chicang-item-box .chicang-item-left{
        flex: 1;
        margin-top: .3rem;
    }
    .chicang-box .chicang-head .chicang-item-box .chicang-item-right{
        flex: 1;
        margin-top: .3rem;
        padding-left: .18rem;
    }
    .chicang-box .chicang-head .chicang-item-box .price1{
        margin-top: .36rem;
        color: #000;
        font-weight: bold;
    }
    .chicang-box .chicang-head .chicang-item-box .price2{
        margin-top: .36rem;
        color: #009962;
        font-weight: bold;
    }
    .chicang-box .chicang-body{
        padding: .18rem 0 .6rem;
    }
    .chicang-box .chicang-body .chicang-body-list{
        display: flex;
        justify-content: space-between;
        align-items: stretch;
    }
    .chicang-box .chicang-body .chicang-body-list .t1{
        margin-top: .36rem;
        color: #7f7f7f;
        font-size: .39rem;
    }
    .chicang-box .chicang-body .chicang-body-list .t2{
        margin-top: .3rem;
        color: #000;
        font-size: .48rem;
    }
    .chicang-box .btn-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .chicang-box .btn-box .btn{
        flex: 1;
        height: .9rem;
        color: #218adc;
        background: #ecf0fc;
        border-radius: .12rem;
        text-align: center;
    }
    .chicang-box .btn-box .btn2{
        margin: 0 .24rem;
    }
    .transaction-box .transaction-left .percent-box{
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: .12rem;
        margin: .45rem 0 .15rem;
        background: #E9E9E9;
    }
    .transaction-box .transaction-left .percent-box .percent{
        position: relative;
        width: 24%;
        height: .12rem;
    }
    .transaction-box .transaction-left .percent-box .percent::after{
        position: absolute;
        right: -.12rem;
        top: 50%;
        z-index: 8;
        content: '';
        width: .24rem;
        height: .24rem;
        border-radius: 100%;
        background: #E9E9E9;
        transform: translateY(-50%);
    }
    .transaction-box .transaction-left .percent-box .percent:first-child{
        width: .24rem;
    }
    .transaction-box .transaction-left .percent-box .percent:first-child::after{
        right: 0;
        left: 0;
    }
    .transaction-box .transaction-left .percent-box .percent.active::after{
        width: .36rem;
        height: .36rem;
        border: 2px solid #53A8F1;
        background: #fff;
    }
    .transaction-box .transaction-left .percent-text{
        padding: .12rem 0;
        color: #7f7f7f;
        font-size: .36rem;
        text-align: right;
    }
    /* 平仓弹窗 */
    .alert-pc{
        position: absolute;
        bottom: 0;
        z-index: 1000;
        width: 100%;
        padding: .48rem .6rem;
        border-radius: .45rem .45rem 0 0;
        background: #fff;
        box-sizing: border-box;
    }
    .alert-pc .alert-pc-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-pc .alert-pc-head .t1{
        color: #009962;
        font-size: .48rem;
        font-weight: 700;
    }
    .alert-pc .alert-pc-head .t2{
        padding-left: .24rem;
        color: #000;
        font-size: .48rem;
        font-weight: 600;
    }
    .alert-pc .alert-pc-head .cancle{
        color: #7f7f7f;
    }
    .alert-pc .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 1.02rem;
        margin-top: .84rem;
        padding: 0 .36rem;
        color: #000;
        line-height: 1.02rem;
        border: 1px solid #d7d7d7;
        border-radius: .12rem;
    }
    .alert-pc .input-box .t1{
        color: #218adc;
    }
    .alert-pc .alert-pc-tips{
        padding: .42rem 0 .72rem;
        color: #7f7f7f;
    }
    .alert-pc .btn,.alert-gg .btn-sure{
        display: block;
        width: 100%;
        margin-top: .42rem;
    }
    .alert-bzj .alert-pc-head{
        justify-content: center;
        font-size: .54rem;
    }
    .alert-bzj .cancle{
        position: absolute;
        right: .6rem;
        font-size: .42rem;
    }
    .alert-bzj .tab-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: .66rem 0 .12rem;
        border: 2px solid #218adc;
    }
    .alert-bzj .tab-box .tab{
        flex: 1;
        height: 1.02rem;
        color: #218adc;
        line-height: 1.02rem;
        text-align: center;
    }
    .alert-bzj .tab-box .tab.active{
        color: #fff;
        background: #218adc;
    }
    .alert-bzj .ul-box .list{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-bzj .ul-box .list .t1{
        flex: 1;
        margin-top: .36rem;
        color: #7f7f7f;
    }
    .alert-bzj .ul-box .list:last-child{
        padding-bottom: .9rem;
    }
    .alert-bzj .ul-box .list .t2{
        flex: 1;
        margin-top: .36rem;
        padding-left: .24rem;
        color: #000;
    }
    .alert-bzj .ul-box .list .zd{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-bzj .ul-box .list .zd .all{
        color: #218adc;
    }
    .alert-bzj .ul-box .list .num-box{
        display: flex;
        align-items: center;
        height: .84rem;
        color: #a3a3a3;
        line-height: .84rem;
        border: 1px solid #d7d7d7;
    }
    .alert-bzj .ul-box .list .num-box .bzj-input-box{
        flex: 1;
        padding-left: .18rem;
    }
    .alert-bzj .ul-box .list .input{
        width: 100%;
    }

    /* 杠杆弹窗 */
    .alert-gg{
        position: absolute;
        left: -1px;
        right: 0;
        bottom: 0;
        z-index: 1000;
        padding: .66rem .72rem .48rem .72rem;
        background: #fff;
        box-sizing: border-box;
    }
    .alert-gg .alert-gg-head{
        position: relative;
        color: #565656;
        font-size: .54rem;
        text-align: center;
    }
    .alert-gg .alert-gg-head .cancle{
        position: absolute;
        right: 0;
        top: 0;
        color: #898989;;
        font-size: .42rem;
    }
    .alert-gg .gg-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 1.02rem;
        margin-top: .75rem;
        line-height: 1.02rem;
    }
    .alert-gg .gg-box .input-box{
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #f2f5f7;
    }
    .alert-gg .gg-box .btn{
        width: 1.08rem;
        color: #6d6d6d;
        background: #e8e8e8;
        text-align: center;
    }
    .alert-gg .gg-box .input{
        width: 100%;
        height: 1.02rem;
        background: #f2f5f7;
        text-align: center;
    }
    .alert-gg .gg-box .dw{
        padding: 0 .3rem;
        color: #a5a5a5;
    }

    .alert-gg .progess-box{
        position: relative;
        margin: 1.26rem .3rem 0 0;
        height: .12rem;
        background: #e8e8e8;
    }
    .alert-gg .progess-box .progess-ul{
        position: absolute;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-gg .progess-box .progess-ul .progess{
        position: relative;
        width: .3rem;
        height: .3rem;
        margin-top: -.18rem;
        background: #e8e8e8;
        border-radius: 50%;
    }
    .alert-gg .progess-box .progess-ul .progess.active{
        width: .48rem;
        height: .48rem;
        margin-top: -.18rem;
        background: #39b4ff;
    }
    .alert-gg .progess-box .progess-ul .progess.active .progess-tips{
        display: block;
    }
    .alert-gg .progess-box .progess-ul .progess-tips{
        display: none;
        position: absolute;
        top: -.84rem;
        width: 1.14rem;
        height: .6rem;
        color: #fff;
        font-size: .36rem;
        line-height: .6rem;
        background: #39b4ff;
        border-radius: .12rem;
        text-align: center;
    }
    .alert-gg .progess-box .progess-ul .progess-tips::after{
        content: '';
        display: block;
        width: 0;
        height: 0;
        margin: -2px 0 0 3px;
        border-left: .18rem solid transparent;
        border-right: .18rem solid transparent;
        border-top: .18rem solid #39b4ff;
        border-bottom: .18rem solid transparent;
    }
    .alert-gg .progess-box .progess-ul .progess-text{
        position: absolute;
        top: .45rem;
    }
    .alert-gg .progess-box .progess-ul .active .progess-text{
        top: .54rem;
    }
    .alert-gg .progess-box .progess-ul .t6{
        left: -.15rem;
    }
    .alert-gg .progess-text .text{
        flex: 1;
    }
    .alert-gg .btn-sure{
        margin-top: 1.5rem;
    }
    .alert-box.currencyTrading{
        position: absolute;
        bottom: 0;
        z-index: 1000;
        width: 100%;
        background: #fafafa;
    }
    .alert-box .alert-item{
        width: 100%;
        height: 1.44rem;
        color: #000;
        line-height: 1.44rem;
        background: #fff;
        text-align: center;
    }
    .alert-box .alert-item.xj{
        border-bottom: 1px solid #e0e0e0;
    }
    .alert-box .alert-item.active{
        color: #218adc;
    }
    .alert-box .btn-cancle{
        margin-top: .18rem;
    }
    /* 左侧弹窗 */
    .alert-left{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1000;
        width: 8.1rem;
        height: 100%;
        background: #fff;
    }
    .alert-left .tab-box{
        position: fixed;
        top: 0;
        left: 0;
        width: 7.38rem;
        display: flex;
        align-items: center;
        margin: 0 .36rem;
        padding: .96rem 0 0;
        color: #7f7f7f;
        font-size: .48rem;
        border-bottom: 1px solid #e0e0e0;
    }
    .alert-left .tab-box .tab{
        padding-bottom: .27rem;
    }
    .alert-left .tab-box .active{
        color: #218adc;
        border-bottom: 2px solid #218adc;
    }
    .alert-left .tab-box .tab:first-child{
        margin-right: .96rem;
    }
    .alert-left .ul-box{
        position: absolute;
        top: 1.86rem;
        bottom: 0;
        width: 100%;
        height: auto;
    }
    .alert-left .ul-box .list .list-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 .36rem;
        padding: .36rem .18rem .36rem 0;
        border-bottom: 1px solid #e0e0e0;
    }
    .alert-left .ul-box .list.active{
        background: #f0f5f7;
    }
    .alert-left .ul-box .list.active .list-box{
        border: none;
    }
    .alert-left .ul-box .list .t1{
        color: #000;
        font-weight: bold;
    }
    .alert-left .ul-box .list .t1 span{
        color: #aaa;
        font-size: .39rem;
        font-weight: normal;
    }
    .alert-left .ul-box .list .price{
        color: #d85656;
    }
</style>



// WEBPACK FOOTER //
// src/pages/perpetualContract.vue